import React from 'react';
import { Thermometer, Zap, Shield, Users, BarChart2, Smartphone } from 'react-feather';

const FEATURES = [
  {
    icon: Thermometer,
    title: 'HVAC & Climate Control',
    desc: 'Adjust temperature, fan speed, and AC mode remotely. Comfort settings that respond instantly via Desigo Optic data points.',
  },
  {
    icon: Zap,
    title: 'Real-time Streaming',
    desc: 'Live sensor values delivered via WebSocket. Temperature, humidity, occupancy, and device states update the moment they change.',
  },
  {
    icon: Shield,
    title: 'Role-based Access',
    desc: 'Admins oversee partners and licenses. Building managers control their sites. Residents manage their own assigned rooms.',
  },
  {
    icon: Users,
    title: 'Multi-tenant Architecture',
    desc: 'Every partner operates in a fully isolated environment. Devices, data, and users are never shared across organizations.',
  },
  {
    icon: BarChart2,
    title: 'Admin Dashboard',
    desc: 'Complete visibility into users, partners, buildings, and device infrastructure from a centralized web management panel.',
  },
  {
    icon: Smartphone,
    title: 'Mobile-first Design',
    desc: 'A purpose-built mobile app brings professional BMS controls to residents. Intuitive, fast, and always in sync.',
  },
];

const FeaturesSection = () => (
  <section className="landing-section" id="features">
    <span className="section-eyebrow">Platform Capabilities</span>
    <h2 className="section-title">Everything Your Building Needs</h2>
    <p className="section-subtitle">
      A complete smart home platform — from device-level control to enterprise user management,
      all built on Siemens infrastructure.
    </p>
    <div className="features-grid">
      {FEATURES.map(f => (
        <div className="feature-card" key={f.title}>
          <div className="feature-icon"><f.icon size={22} /></div>
          <h5>{f.title}</h5>
          <p>{f.desc}</p>
        </div>
      ))}
    </div>
  </section>
);

export default FeaturesSection;
